import { Loader } from '@googlemaps/js-api-loader'
import { useState, useEffect } from 'react'

let _apiLoaded = false

const _loadMapsApi = async () => {
  if (!_apiLoaded) {
    try {
      const apiLoader = new Loader({
        apiKey: process.env.GOOGLE_APIS_CLIENT_KEY,
        version: 'weekly',
      })
      await apiLoader.load()
      _apiLoaded = true
    } catch (e) {
      /* eslint-disable-next-line no-console */
      console.error('Error loading Google Maps API', e)
    }
  }
  return _apiLoaded
}

const _radians = (degrees) => {
  return (degrees * Math.PI) / 180
}

const getDistance = (coordinates1, coordinates2) => {
  const R = 6371

  const radLat1 = _radians(coordinates1.lat)
  const radLon1 = _radians(coordinates1.lng)
  const radLat2 = _radians(coordinates2.lat)
  const radLon2 = _radians(coordinates2.lng)

  const dlon = radLon2 - radLon1
  const dlat = radLat2 - radLat1
  const a = (Math.sin(dlat / 2) ** 2)
    + (Math.cos(radLat1) * Math.cos(radLat2) * (Math.sin(dlon / 2) ** 2))
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
  const distance = R * c

  return distance
}

const useLoadScripts = () => {
  const [isLoaded, setIsLoaded] = useState(false)
  const [loadError, setLoadError] = useState(null)

  useEffect(() => {
    const loadScripts = async () => {
      const loaded = await _loadMapsApi()
      if (loaded) {
        setIsLoaded(true)
      } else {
        setLoadError(true)
      }
    }
    loadScripts()
  }, [])
  return { isLoaded, loadError }
}

const resetBrowserServicesForTesting = () => {
  _apiLoaded = false
}

export {
  getDistance,
  useLoadScripts,
  resetBrowserServicesForTesting,
}
